import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonConfig, DEFAULT_BUTTON_CONFIG } from './button.modal';

@Component({
  selector: 'ds-button',
  templateUrl: './button.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ButtonComponent {
  @Output() btnClick = new EventEmitter<Event>();

   public _buttonInput: ButtonConfig = { ...DEFAULT_BUTTON_CONFIG };
  @Input() buttonInput!: ButtonConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.buttonInput) {
      const val: ButtonConfig = changes.buttonInput.currentValue || {};
      this.buttonInput = { ...DEFAULT_BUTTON_CONFIG, ...val };
    }
  }

  onClick(event: Event) {
    if (!this.buttonInput.disabled && !this.buttonInput.loading) {
      this.btnClick.emit(event);
    }
  }
}
